import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function UploadDocuments() {
  const [selectedCategory, setSelectedCategory] = useState('Director Data');
  const categories = ['Director Data', 'Company Info', 'Carrier agreements', 'Other'];
  return <div className="bg-white rounded-lg shadow" data-id="element-2590">
      <div className="p-6" data-id="element-2591">
        <h2 className="text-xl font-semibold mb-6" data-id="element-2592">
          Upload Supporting Documents
        </h2>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-2593">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2594">
            <h3 className="font-medium text-lg mb-4" data-id="element-2595">Document Upload</h3>
            <div className="mb-4" data-id="element-2596">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2597">
                Document Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-2598">
                {categories.map(category => <option key={category} value={category} data-id="element-2599">
                    {category}
                  </option>)}
              </select>
            </div>
            <FileUploader data-id="element-2600" />
            <div className="mt-6 text-sm text-gray-500" data-id="element-2601">
              <p data-id="element-2602">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX</p>
              <p data-id="element-2603">Maximum file size: 10MB</p>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2604">
            <h3 className="font-medium text-lg mb-4" data-id="element-2605">Document Requirements</h3>
            <div className="space-y-4" data-id="element-2606">
              <div data-id="element-2607">
                <h4 className="font-medium" data-id="element-2608">Director Data</h4>
                <p className="text-sm text-gray-600" data-id="element-2609">
                  Personal information for all company directors including ID
                  verification documents.
                </p>
              </div>
              <div data-id="element-2610">
                <h4 className="font-medium" data-id="element-2611">Company Info</h4>
                <p className="text-sm text-gray-600" data-id="element-2612">
                  Company registration documents, business address proof, and
                  corporate structure.
                </p>
              </div>
              <div data-id="element-2613">
                <h4 className="font-medium" data-id="element-2614">Carrier agreements</h4>
                <p className="text-sm text-gray-600" data-id="element-2615">
                  All existing carrier and capacity provider agreements.
                </p>
              </div>
              <div data-id="element-2616">
                <h4 className="font-medium" data-id="element-2617">Other</h4>
                <p className="text-sm text-gray-600" data-id="element-2618">
                  Any other supporting documentation relevant to your
                  application.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}